import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import { StaticDatePicker } from '@mui/x-date-pickers-pro';
import { Moment } from 'moment';
import colors from '../../../../common/colors';
import QuickFilters from '../QuickFilters';
import type {
  DateRange,
  MobileStep,
  QuickFilter,
  CalendarView,
} from '../../types';

interface MobileViewProps {
  mobileStep: MobileStep;
  setMobileStep: (step: MobileStep) => void;
  setCurrentView: (view: CalendarView) => void;
  dateRange: DateRange;
  handleMobileDateChange: (newValue: Moment | null) => void;
  selectedFilter: string | null;
  handleQuickSelect: (key: string) => void;
  filters: QuickFilter[];
}

const MobileView: React.FC<MobileViewProps> = ({
  mobileStep,
  setMobileStep,
  setCurrentView,
  dateRange,
  handleMobileDateChange,
  selectedFilter,
  handleQuickSelect,
  filters,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: colors.white,
        borderRadius: 1,
        mt: 1,
        p: 2,
        maxHeight: '80vh',
        overflowY: 'auto',
        boxSizing: 'border-box',
        '& .MuiPickersLayout-root': {
          maxWidth: '100%',
        },
        '& .MuiDayCalendar-root': {
          maxWidth: '100%',
        },
      }}
    >
      {mobileStep === 'start' && (
        <Box data-calendar-type="start" display="flex" flexDirection="column">
          <Box
            display="flex"
            alignItems="center"
            sx={{
              mb: 2,
            }}
          >
            <Typography bgcolor="white" variant="body1">
              Start date
            </Typography>
          </Box>
          <Box
            display="flex"
            sx={{
              mb: 2,
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            <QuickFilters
              selectedFilter={selectedFilter}
              onQuickSelect={handleQuickSelect}
              filters={filters}
            />
          </Box>
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            value={dateRange[0]}
            views={['year', 'month', 'day']}
            onViewChange={setCurrentView}
            onChange={handleMobileDateChange}
            sx={{
              width: '100%',
              maxWidth: '100%',
              '& .MuiPickersLayout-root': {
                maxWidth: '100%',
              },
            }}
          />
        </Box>
      )}

      {mobileStep === 'end' && (
        <Box data-calendar-type="end" display="flex" flexDirection="column">
          <Box
            display="flex"
            alignItems="center"
            sx={{
              mb: 2,
            }}
          >
            <IconButton onClick={() => setMobileStep('start')} size="small">
              <ChevronLeft />
            </IconButton>
            <Typography bgcolor="white" variant="body1" sx={{ ml: 1 }}>
              End date
            </Typography>
          </Box>
          <Box
            sx={{
              mb: 2,
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            <QuickFilters
              selectedFilter={selectedFilter}
              onQuickSelect={handleQuickSelect}
              filters={filters}
            />
          </Box>
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            value={dateRange[1]}
            views={['year', 'month', 'day']}
            onViewChange={setCurrentView}
            shouldDisableDate={(date) =>
              dateRange[0] ? date.isBefore(dateRange[0], 'day') : false
            }
            onChange={handleMobileDateChange}
            sx={{
              width: '100%',
              maxWidth: '100%',
              '& .MuiPickersLayout-root': {
                maxWidth: '100%',
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default MobileView;
